module.exports = __webpack_public_path__ + "static/media/role1.89adfa1e.png";